module.exports = __webpack_public_path__ + "assets/img/visa.6d6831bd.jpg";